export default __webpack_public_path__ + "static/media/slide1.e83da956.png";